import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as MyProfileReset } from '../../../../assets/images/myprofile_reset.svg';

const ProfileResetIcon = (props) => {
  const { isActive, ...otherProps } = props; // Destructure isActive prop
  return (
    <SvgIcon {...otherProps} component={MyProfileReset} viewBox="0 0 24 24" />
  );
};

export default ProfileResetIcon;
